import type { KeyboardEvent } from 'react';

/** The keys a checkbox answers to. */
const TOGGLE_KEYS = new Set([' ', 'Enter']);

/**
 * A keydown handler that makes an element answer the keyboard as a checkbox:
 * Space or Enter pressed on the element itself calls `toggle` with it. A key
 * bubbling out of the element's contents is left alone — it belongs to what is
 * inside.
 *
 * Shared by every exportable item, so a table, a chart and a stretch of prose
 * cannot come to answer different keys.
 */
export function onCheckboxKey(toggle: (element: HTMLDivElement) => void) {
  return (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.target !== event.currentTarget || !TOGGLE_KEYS.has(event.key)) return;
    event.preventDefault();
    toggle(event.currentTarget);
  };
}
